<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <!--<v-responsive :aspect-ratio="16 / 9">-->
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">
                  {{ $t("dispatching.dispatching.heading") }}
                </div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <!-- <label style="font-size: large"
                  >Minimum minutes to add scheduled order to besoin</label
                > -->
                <v-layout justify-start align-center>
                  <v-select
                    outline
                    :label="$t('dispatching.dispatching.algorithm')"
                    :items="testData"
                    style="max-width: 220px"
                    v-model="first"
                    :rules="[rules.required]"
                  ></v-select>

                  <v-menu
                    ref="menu1"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time"
                        style="margin-left: 15px"
                        :label="$t('dispatching.dispatching.chooseValue')"
                        readonly
                        outline
                        :rules="[rules.required]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu2"
                      v-model="time"
                      full-width
                      :allowed-minutes="allowedMinutes"
                      @click:minute="$refs.menu1.save(time)"
                      @change="test"
                    ></v-time-picker>
                  </v-menu>
                </v-layout>

                <v-layout justify-start align-center>
                  <v-select
                    outline
                    :label="$t('dispatching.dispatching.algorithm')"
                    :items="testData"
                    style="max-width: 220px"
                    v-model="second"
                    :rules="[rules.required]"
                  ></v-select>
                  <v-menu
                    ref="menu"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time2"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time2"
                        :label="$t('dispatching.dispatching.switchTime')"
                        readonly
                        outline
                        :rules="[rules.required]"
                        v-on="on"
                        style="margin-left: 15px"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu3"
                      v-model="time2"
                      full-width
                      :allowed-minutes="allowedMinutes"
                      @click:minute="$refs.menu.save(time2)"
                    ></v-time-picker>
                  </v-menu>

                  <!-- </v-flex> -->
                </v-layout>

                <v-layout justify-start align-center>
                  <v-select
                    outline
                    :label="$t('dispatching.dispatching.algorithm')"
                    :items="testData"
                    style="max-width: 220px"
                    v-model="third"
                    :rules="[rules.required]"
                  ></v-select>
                  <v-menu
                    ref="menuu"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time3"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time3"
                        :label="$t('dispatching.dispatching.switchTime')"
                        readonly
                        outline
                        :rules="[rules.required]"
                        v-on="on"
                        style="margin-left: 15px"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu4"
                      v-model="time3"
                      full-width
                      :allowed-minutes="allowedMinutes"
                      @click:minute="$refs.menuu.save(time3)"
                    ></v-time-picker>
                  </v-menu>

                  <!-- </v-flex> -->
                </v-layout>

                <v-layout justify-start align-center>
                  <v-select
                    outline
                    :label="$t('dispatching.dispatching.algorithm')"
                    :items="testData"
                    style="max-width: 220px"
                    v-model="fourth"
                    :rules="[rules.required]"
                  ></v-select>
                  <v-menu
                    ref="menuu4"
                    v-model="menu5"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time4"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time4"
                        :label="$t('dispatching.dispatching.switchTime')"
                        readonly
                        outline
                        :rules="[rules.required]"
                        v-on="on"
                        style="margin-left: 15px"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu5"
                      v-model="time4"
                      full-width
                      :allowed-minutes="allowedMinutes"
                      @click:minute="$refs.menuu4.save(time4)"
                    ></v-time-picker>
                  </v-menu>

                  <!-- </v-flex> -->
                </v-layout>

                <v-btn :loading="loading" block @click="save" color="secondary"
                  >{{ $t("common.save") }}
                </v-btn>
              </v-form>
            </v-flex>
            <!--</v-responsive>-->
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("dispatching.dispatching.title");
  },
  data: () => ({
    loading: false,
    first: "",
    second: "",
    third: "",
    fourth: "",
    form: false,
    time: null,
    time2: null,
    time3: null,
    time4: null,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    testData: ["day", "night", "classic", "hot", "new_classic"],

    model: {
      first: "",
      second: "",
    },

  }),
  computed: {
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("dispatching.dispatching.invalidLength", { len }),

        required: (v) => !!v || this.$t("common.required"),
      };
    },
  },
  mounted() {
    axios.get("setting").then((response) => {
      console.log("response");
      console.log(response.data.data);
      this.settings = response.data.data;
      this.first = this.settings.COND1_ALGO;
      this.second = this.settings.COND2_ALGO;
      this.third=this.settings.COND3_ALGO
      this.fourth=this.settings.COND4_ALGO
      this.time = this.settings.COND1_TIME;
      this.time2 = this.settings.COND2_TIME;
      this.time3 = this.settings.COND3_TIME;
      this.time4 = this.settings.COND4_TIME;
    });
  },

  methods: {
    test() {
      console.log(this.time);
    },
    allowedMinutes: (v) => v == 15 || v == 30 || v == 45 || v == 0,
    save() {
      if (this.$refs.form.validate()) {
        // window.getApp.$emit(
        //   "SHOW_TOAST",
        //   "Please enter a valid number ",
        //   "red"
        // );
        this.loading = true;
        let setty = {};

        setty.COND1_TIME = this.time;
        setty.COND2_TIME = this.time2;
        setty.COND3_TIME = this.time3;
        setty.COND4_TIME = this.time4;

        setty.COND1_ALGO = this.first;
        setty.COND2_ALGO = this.second;
        setty.COND3_ALGO = this.third;
        setty.COND4_ALGO = this.fourth;
        // setty.value = this.first;
        // setty.value1 = this.second;

        console.log("this settings");
        console.log(setty);
        this.axios
          .put(`setting/update`, setty)
          .then(() => window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.dispatching.settingsSaved")))
          .catch(({ response }) => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("dispatching.dispatching.saveFailed"),
              "red"
            );
            console.log(response);
          })
          .finally(() => (this.loading = false));
        return;
      }
    },
  },
};
</script>
